<div class="flex justify-between h-[90vh]">
  <app-side-dialog class="w-full" [fullHeight]="true">
    <div dialogHeader class="flex items-center w-full">
      <div class="flex items-center">
        <span
          class="font-medium text-[28px] text-ellipsis line-clamp-1 max-w-80"
          matTooltipPosition="above"
          matTooltip
          [appTextClampTooltip]="dialogTitle()"
        >
          {{ dialogTitle() }}
        </span>
      </div>
    </div>

    <div class="dialog-content h-full" dialogContent>
      @if (dummyExecution()) {
        @let execution = dummyExecution()!;

        <div class="flex w-full h-full">
          <!-- Left Column: Tile and KPIs -->
          <div class="flex flex-col gap-3 w-[272px] shrink-0 overflow-y-auto pr-6 -mr-6">
            <div class="flex items-center justify-center self-stretch">
              <app-social-content-tile
                class="w-[248px] self-stretch"
                [tileConfiguration]="tileConfiguration()"
                [clickable]="false"
                [dialogMode]="true"
                [noCampaignContextMode]="true"
                (click)="$event.stopPropagation()"
              />
            </div>

            <app-cta-analytics-details-kpis-tile
              class="self-stretch"
              [execution]="execution"
              [kpiCardData]="kpiCardDataForKpisTile()"
              [platformFeature]="execution.platformFeature"
              [noCampaignContextMode]="true"
            />
          </div>

          <!-- Vertical Divider -->
          <div class="shrink-0 w-px self-stretch ml-6 bg-shikenso-purple-base-12"></div>

          <!-- Right Column: Deliverables and Content -->
          <div class="flex flex-col gap-4 flex-1 min-w-0 w-full justify-center items-center">
            <span class="text-shikenso-purple-base-60 font-bold text-[28px]">
              {{ 'pages.creatorDetails.socialContentDialog.noAnalyticsAvailable' | translate }}
            </span>
          </div>
        </div>
      }
    </div>
  </app-side-dialog>
</div>
